import api, { twUrl } from '../../utils/api';
import { UserDisplaySettings, UserResponse } from '../User/User.model';
import { AccountData, AccountTimezone } from './Account.model';
import { AppSetting, AppSettingsRequestModel } from './AppSettings.model';
import {
  LoadNotificationSettingsRequest,
  LoadNotificationSettingsResponse
} from './LoadNotificationSettings.model';

class SettingsService {
  /**
   * Gets available timezones
   */
  static getTimezones(): Promise<AccountTimezone[]> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(twUrl.getTimezones);

      apiResponse
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  }

  /**
   * Updates user account data
   */
  static updateAccount(accountData: AccountData): Promise<UserResponse> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.put(twUrl.updateAccount, accountData);

      apiResponse
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }

  /**
   * Get app Settings
   */
  static getAppSettings(): Promise<AppSetting[]> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(twUrl.appSettings);

      apiResponse
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  }

  static updateSettings(requestBody: AppSettingsRequestModel): Promise<AppSetting[]> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.put(twUrl.appSettings, requestBody);

      apiResponse
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  }

  /**
   * Get Load notification settings (general or for specific load)
   */
  static getOrderNotificationSettings(orderId?: string): Promise<LoadNotificationSettingsResponse> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.get(
        orderId
          ? twUrl.v3.getOrderNotificationSettingsByOrderId(orderId)
          : twUrl.v3.getDefaultOrderNotificationSettings
      );

      apiResponse
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  }

  /** Update load notification settings (general or for specific load)
   * @param settingsParams - settings params
   * @param configId - configuration id
   * @param orderId
   * */
  static updateLoadNotificationSettings(
    settingsParams: LoadNotificationSettingsRequest,
    configId?: string,
    orderId?: string
  ): Promise<LoadNotificationSettingsResponse> {
    return new Promise((resolve, reject) => {
      const body = {
        ...settingsParams,
        order_id: orderId || null
      };

      const apiResponse = api.put(twUrl.v3.updateOrderNotificationSettings(configId), body);

      apiResponse
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  }

  /**
   * Updates user display settings
   * currently only supports customization of All loads table
   *
   */
  static updateUserDisplaySettings(displaySettings: UserDisplaySettings): Promise<unknown> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.post(twUrl.updateUserDisplaySettings, displaySettings);

      apiResponse
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }
}

export default SettingsService;
